import PlanDetailsCompareDialog from './plan-details.vue';
import { ServiceConfirm } from '@/components/common/service-dialog/confirm';
import { mapState } from 'vuex';
import { planTypes } from '@/common/constants';
import { logger } from '@/utils/log';

export default {
  computed: {
    ...mapState({
      planMapFlat: (state) => state.ShoppingCart.planMapFlat,
    }),
  },
  created() {
    this.planDetailsCompareDialog = new ServiceConfirm(PlanDetailsCompareDialog);
  },
  methods: {
    async showPlanDetailDialog() {
      try {
        // do tracking when open plan details dialog
        this.$tracking.buyInteraction('plan details selected',this.trackingPlanKey);
        await this.planDetailsCompareDialog.confirm({
          planList: this.planList.sort((a, b) => a.cycleValue - b.cycleValue),
          planType: planTypes.ZOOM_CLIPS,
          title: this.title,
          planCategory: this.selectedPlan?.category,
        });
      } catch (error) {
        logger.warn('Failed to show plan detail dialog or hidden the dialog', error);
      }
    },
  },
};
